export default "__VITE_ASSET__BEAiTAo6__"